<template>
    <TicketsWidgetContainer v-if="shouldShow"/>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    // import { errorGuard } from '@app/utils';
    import TicketsWidgetContainer from './TicketsWidgetContainer';

    export default {
        name: 'TicketsWidget',
        data() {
            return {
                authenticated: false,
            };
        },
        watch: {
            user(newValue) {
                this.authenticated = !!newValue;
            }
        },
        async created() {
            // await errorGuard({
            //     action: async () => {
            //         this.authenticated = await this.isAuthenticated();
            //     }
            // });
        },
        methods: {
            ...mapActions('data/authentication', [
                'isAuthenticated',
            ]),
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
            ...mapGetters('data/sportOffer', [
                'isOfferReady',
            ]),
            shouldShow() {
                // If there's user data present in localStorage, check whether the user is authenticated.
                // If not, wait for the user to login.
                return this.user && this.authenticated && this.isOfferReady;
            }
        },
        components: {
            TicketsWidgetContainer,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/TicketsWidget.vue